var getUrlQuery			= require('../helpers/getUrlQuery');

function seasonChange() {

	var isSeason = getUrlQuery()["season"],
		$body = document.getElementsByTagName('body')[0],
		$seasonItem = $('.season-item'),
		$actualSeason = $('.actual-season'),
		$seasonChange = $('.season-change'),
		summerSeasonTxt = $seasonChange.attr('data-summer-txt'),
		winterSeasonTxt = $seasonChange.attr('data-winter-txt'),
		dataSeasonHead = $('.header').attr('data-season-head');

	if(isSeason && typeof isSeason !== 'undefined') {

		$body.setAttribute('data-season', isSeason);

		if(isSeason == 'summer') {

			var url = $('.site-logo').attr('href'),
				url = url.replace('summer', 'winter');

			$actualSeason.text(summerSeasonTxt);

			$seasonItem.attr('href', url).text(winterSeasonTxt);

		} else if(isSeason == 'winter') {

			var url = $('.site-logo').attr('href'),
				url = url.replace('winter', 'summer');

			$actualSeason.text(winterSeasonTxt);

			$seasonItem.attr('href', url).text(summerSeasonTxt);

		}

	} else if(isSeason === undefined) {

		var url = $('.site-logo').attr('href');

		$body.setAttribute('data-season', dataSeasonHead);

		if($body.getAttribute('data-season') === 'winter') {
			if(url.indexOf('?') > -1) {
				$seasonItem.attr('href', url+'&season=summer').text(summerSeasonTxt);
			} else {
				$seasonItem.attr('href', url+'?season=summer').text(summerSeasonTxt);
			}
		} else if($body.getAttribute('data-season') === 'summer') {
			if(url.indexOf('?') > -1) {
				$seasonItem.attr('href', url+'&season=winter').text(winterSeasonTxt);
			} else {
				$seasonItem.attr('href', url+'?season=winter').text(winterSeasonTxt);
			}
		}

	}

	$('.summer_station').on('mouseenter touchstart', function() {
		var _thisAttr = $(this).attr('data-summer-href');

		$(this).attr('href', _thisAttr+'?season=summer');
	});

	$('.winter_station').on('mouseenter touchstart', function() {
		var _thisAttr = $(this).attr('data-winter-href');

		$(this).attr('href', _thisAttr+'?season=winter');
	});
	
};

module.exports = seasonChange;